import React, { useEffect } from 'react';

import { Box, Grid } from '@mui/material';
import { Outlet } from 'react-router-dom';

import {
  displaySelectPackageSelect,
  getTypeOfUser,
  getUserConfigurations,
  isUserFirstTimeLogin,
  pharmacyBillingSelector,
  TypeOfUser,
} from '@pharmaplan/common';

import useClientUnreadChats from '../../hooks/Chat/useClientUnreadChats/useClientUnreadChats';
import useHandleBookingCancel from '../../hooks/useHandleBookingCancel';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useAppSelector } from '../../hooks/useAppSelector';
import { setDialog } from '../../reducers/dialogReducer';
import useSelfService from '../../hooks/useSelfService';
import WelcomeToPharmaGap from '../WelcomeToPharmaGap';
import NavToolBar from '../Navbar/NavToolBar';

import Navbar from '../Navbar';
import classes from './style';

const { mainContainer, content, contentContainer } = classes;
const loadedKey = 'isLoaded';

const Home = () => {
  const dispatch = useAppDispatch();

  const userType = useAppSelector(getTypeOfUser);
  const displayPackagePopup = useAppSelector(displaySelectPackageSelect);
  const { isSelfService } = useSelfService();

  const isFirstLogin = useAppSelector(isUserFirstTimeLogin);
  const isLoaded = localStorage.getItem(loadedKey) === 'true';
  const isPharmacy = userType === TypeOfUser.pharmacy;
  const billing = useAppSelector(pharmacyBillingSelector);

  const isPharmacistFirstLogin = !isPharmacy && isFirstLogin;
  const isPharmacyFirstLogins = isPharmacy && displayPackagePopup && !billing?.creditCardLast4;
  const showFirstLogin = !isPharmacy
    ? isPharmacistFirstLogin
    : isPharmacyFirstLogins;

  useHandleBookingCancel();
  useClientUnreadChats();

  useEffect(() => {
    dispatch(getUserConfigurations());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (showFirstLogin && !isLoaded && isSelfService) {
      localStorage.setItem(loadedKey, 'true');
      dispatch(
        setDialog({
          Component: <WelcomeToPharmaGap />,
          showCloseButton: true,
          heading: { title: '' },
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showFirstLogin]);

  return (
    <Box sx={mainContainer} component="div">
      <Grid sx={contentContainer} item sm={11}>
        {/* TopBar */}
        <Box component="div">
          <Navbar BottomToolbar={<NavToolBar />} />
        </Box>
        {/* Content */}
        <Box sx={content}>
          <Outlet />
        </Box>
      </Grid>
    </Box>
  );
};

export default Home;
